import { useState, useEffect } from 'react'
import { renderMarkdown, formatDate } from '@/utils/markdown'
import type { BlogPost } from './Writing'

export function ArticleView({ post, onBack }: { post: BlogPost; onBack: () => void }) {
  const [content, setContent] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    window.scrollTo(0, 0)
    setLoading(true)
    fetch(`/blog/posts/${post.slug}.md`)
      .then((r) => r.ok ? r.text() : null)
      .then((text) => {
        setContent(text)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [post.slug])

  return (
    <div className="modern-mode">
      <nav className="modern-nav modern-nav--scrolled">
        <button className="modern-nav__logo modern-article__back" onClick={onBack}>
          &larr; Back
        </button>
      </nav>
      <article className="modern-article">
        <header className="modern-article__header">
          <div className="modern-post__meta">
            <time className="modern-post__date">{formatDate(post.date)}</time>
            <span className="modern-post__category">{post.category}</span>
            {post.voiceRecorded && (
              <span className="modern-post__voice">voice-recorded</span>
            )}
            {post.readTime && (
              <span className="modern-post__date">{post.readTime}</span>
            )}
          </div>
          <h1 className="modern-article__title">{post.title}</h1>
        </header>
        {loading ? (
          <p className="modern-about__text">Loading...</p>
        ) : content ? (
          <div
            className="modern-article__body"
            dangerouslySetInnerHTML={{ __html: renderMarkdown(content) }}
          />
        ) : (
          <p className="modern-about__text">Could not load article.</p>
        )}
      </article>
    </div>
  )
}
